import React from "react";
import { Icon } from "shared/styles";

import { StyledButtonLink, StyledLinkProps } from "./styles";

interface FancyButtonLinkProps extends StyledLinkProps {
  onClick: () => void;
  type?: "button" | "submit";
  icon?: React.ComponentType<any>;
  "data-testid"?: string;
  disabled?: boolean;
}

export const FancyButtonLink: React.FC<FancyButtonLinkProps> = ({
  onClick,
  type = "button",
  icon,
  children,
  ...rest
}) => {
  return (
    <StyledButtonLink onClick={onClick} type={type} {...rest}>
      {icon && <Icon as={icon} />}
      <span>{children}</span>
    </StyledButtonLink>
  );
};
